<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-29 14:07:18
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-31 10:13:27
-->
<template>
	<empty :isSearch="isSearch" @btnClick="btnClick" :btnText="btnText" :btnShow="btnShow">
		<p slot="desc" class="fz-16 pre yx-color-text-primary">{{ emptyText }} </p>
	</empty>
</template>
<script>
import authMixin from '@/modules/auth/mixin';
import { tzRoleType, zsRoleType } from '@/utils/dataMap';
const searchEmptyText = '暂无筛选结果，请调整筛选条件';
const noAuthBossEmptyText = '账号未授权，授权后才能展示商品';
const noAuthOthersEmptyText = '账号未授权，请联系管理员授权后才能展示商品';
export default {
	name: 'GoodsEmpty',
	mixins: [authMixin],
	props: {
		isSearch: {
			type: Boolean,
			default: false,
		},
		platformId: {
			type: [Number, String],
			default: '',
		},
		source: {
			type: String,
			default: 'group',
			validator: val => ['group', 'library'].includes(val),
		},
		hasGoods: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		
	},
	created() {
		this.getAuthInfo();
	},
	data() {
		return {
			noAuth: false,
		};
	},
	computed: {
		tzName() {
			return tzRoleType.name;
		},
		zsName() {
			return zsRoleType.name;
		},
		conf() {
			return {
				group: {
					hasGoods: {
						hasAuth: {
							isBoss: {
								empty: searchEmptyText,
							},
							isDarenPartner: {
								empty: searchEmptyText,
							},
						},
						noAuth: {
							isBoss: {
								empty: searchEmptyText,
							},
							isDarenPartner: {
								empty: searchEmptyText,
							},
						},
					},
					noGoods: {
						hasAuth: {
							isBoss: {
								empty: searchEmptyText,
							},
							isDarenPartner: {
								empty: searchEmptyText,
							},
						},
						noAuth: {
							isBoss: {
								empty: noAuthBossEmptyText,
								showBtn: true,
								btnText: '前往授权',
								btnClick: () => this.$emit('btnClick'),
							},
							isDarenPartner: {
								empty: noAuthOthersEmptyText,
							},
						},
					},
				},
				library: {
					hasGoods: {
						hasAuth: {
							isBoss: {
								empty: searchEmptyText,
							},
							isDarenPartner: {
								empty: searchEmptyText,
							},
						},
						noAuth: {
							isBoss: {
								empty: searchEmptyText,
							},
							isDarenPartner: {
								empty: searchEmptyText,
							},
						},
					},
					noGoods: {
						hasAuth: {
							isBoss: {
								empty: `请联系${this.tzName}分配或${this.zsName}认领团长活动商品，\n分配或认领后商品将在商品库展示`,
							},
							isDarenPartner: {
								empty: `请联系${this.tzName}分配或${this.zsName}认领团长活动商品，\n分配或认领后商品将在商品库展示`,
							},
						},
						noAuth: {
							isBoss: {
								empty: noAuthBossEmptyText,
								showBtn: true,
								btnText: '前往授权',
								btnClick: () => this.$emit('btnClick'),
							},
							isDarenPartner: {
								empty: noAuthOthersEmptyText,
							},
						},
					},
				},
			};
		},
		goodsType({ hasGoods }) {
			return hasGoods ? 'hasGoods' : 'noGoods';
		},
		authType({ noAuth }) {
			return noAuth ? 'noAuth' : 'hasAuth';
		},
		roleType() {
			return this.$auth.hasPermi('system:goods-synchronous') ? 'isBoss' : 'isDarenPartner';
		},
		emptyText({ conf, source, goodsType, authType, roleType }) {
			return conf[source][goodsType][authType][roleType].empty;
		},
		btnText({ conf, source, goodsType, authType, roleType }) {
			return conf[source][goodsType][authType][roleType].btnText;
		},
		btnShow({ conf, source, goodsType, authType, roleType }) {
			return conf[source][goodsType][authType][roleType].showBtn;
		},
		btnClick({ conf, source, goodsType, authType, roleType }) {
			return conf[source][goodsType][authType][roleType].btnClick || (() => {});
		},
	},
	methods: {
		async getAuthInfo() {
			try {
				const { bind_status } = await this.fetchAuthInfo(this.platformId);
				this.noAuth = !bind_status;
			} catch (error) {
				this.noAuth = false;
			}
		},
		gotoGroupPage() {
			this.$router.push({ path: '/shopManage/tobeClaime/list', query: { platformId: this.platformId } });
		},
	},
};
</script>
